import store from "@/lobby_common/store";
// import { getLocalStorage, removeToken, setLocalStorage } from './auth'
// import { divideAccuracy } from '@/lobby_common/utils/utils.js'
// import Bus from './bus.js'
// import { formatTime } from './utils'
// import { isGame } from "@/lobby_common/utils/utils.js";
let open_proto = null;

async function loadProto() {
  if (!open_proto) {
    try {
      const module = await import("@/lobby_common/webProto/proto.js");
      open_proto =
        module.open_proto ||
        module.default?.open_proto ||
        module.default ||
        null;
    } catch (error) {
      this.$eventPost("ws_log", {});
      open_proto = null;
    }
  }
  return open_proto;
}
import {
  isMobile,
  generateKey,
  getContainerClientType,
} from "@/lobby_common/utils/utils";
// import Fingerprint2 from "fingerprintjs2";
// import { generateKey } from "@/lobby_common/utils/utils";
// import { open_proto } from "@/lobby_common/webProto/proto.js";
import wsFun, { sendLoadProto } from "@/lobby_common/utils/wsFun.js";
const date = Date.parse(new Date());
window.localStorage.setItem("wsstype", date);
window.sessionStorage.setItem("wsstype", date);
export default {
  data() {
    return {
      wssTypedata: true,
      initWebSockettype: false,
      exitKicktype: false, // 判断推送后端返回是不是挤号
      websock: null, // 建立的连接
      lockReconnect: false, // 是否真正建立连接
      timeout: 5 * 1000, // 5秒一次心跳
      timeoutObj: null, // 心跳心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null, // 断开 重连倒计时
      clear_setInterval: null, // 清除定时器
      wssType: null, // 推送状态
      wssdataboxsetInterval: null,
      counter: 0,
      wsuriParam: {},
      headBUff: undefined,
      requestArr: [],
      pushArr: [],
      browserdata: {},
    };
  },
  computed: {
    getToken() {
      return this.$store.getters.taken;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    getPacketDomain() {
      return this.$store.getters.getPacketDomain || {};
    },
  },
  beforeCreate() {
    // const date = Date.parse(new Date());
    // window.localStorage.setItem("wsstype", date);
    // window.sessionStorage.setItem("wsstype", date);
    // window.sessionStorage.setItem("wsstyp1111e", "1111111");
    // this.wssType = date;
    // this.wssType = window.sessionStorage.getItem("wsstype");
    // if (typeof window.sessionStorage !== "undefined") {
    //   window.sessionStorage.setItem("wsstype", date);
    //   console.log("sessionStorage 可用");
    // } else {
    //   console.log("sessionStorage 不可用");
    // }
    // console.log(this.wssType, " this.wssType");
  },
  async created() {
    await this.createHeadBUff();
    this.pushArrFun();
    // 刷新token后需要重连
    console.log("刷新token后需要重连", date);
    window.sessionStorage.setItem("wsstype", date);
    this.$Bus.$on("reconnectWebSocket", () => {
      this.reset();
      this.websock?.close();
      this.initWebSocket();
    });
  },
  watch: {
    getToken: {
      handler(val, oval) {
        // console.log(val, oval, "--------initWebSocket----------------")
        if (!val) {
          //   console.log("-------isLogin------ websocketclose-------");
          this.reset();
          this.websock?.close();
          //   this.websocketclose();
        } else {
          // 登录后开启长连接
          // this.initWebSocket();
          console.log(1111111, "--------initWebSocket----------------");
          if (val && this.getPacketDomain) {
            if (this.wssTypedata) {
              if (this.getPacketDomain.websocketUrl) {
                this.wssTypedata = false;
              }
              this.initWebSockettype = true;
              // console.log(date, "this.wssType ");
              window.sessionStorage.setItem("wsstype", date);
              console.log(2222, "--------initWebSocket----------------");
              this.initWebSocket();
            }
          }
        }
      },
      immediate: true, // 刷新加载 立马触发一次handler
      deep: true,
    },
    getPacketDomain: {
      handler(val, oval) {
        window.sessionStorage.setItem("wsstype", date);
        if (this.initWebSockettype) {
          if (!val) {
            // console.log("-------getPacketDomain------ websocketclose-------");
            this.reset();
            this.websock?.close();
            // this.websocketclose();
          } else {
            if (this.getToken && this.getPacketDomain) {
              // 登录后开启长连接
              // this.initWebSocket();

              if (val !== oval) {
                if (this.wssTypedata) {
                  if (this.getPacketDomain.websocketUrl) {
                    this.wssTypedata = false;
                  }
                  this.initWebSockettype = true;
                  this.initWebSocket();
                }
              }
            }
          }
        }
      },
      immediate: true, // 刷新加载 立马触发一次handler
      deep: true,
    },
  },

  destroyed() {
    // 页面销毁时关闭长连接
    // console.log("-------destroyed------ websocketclose-------");
    this.websocketclose();
  },
  methods: {
    async createHeadBUff() {
      try {
        const open_proto = await loadProto();
        sendLoadProto(open_proto);
        if (open_proto) {
          const protodata = (open_proto.websocket.IRequest = {
            action: open_proto.websocket.Action.REQ_ACTION_EVENT,
            path: "/open_proto.websocket.WebsocketPush/PingPong",
            body: open_proto.websocket.PingPongReq.encode(
              open_proto.websocket.PingPongReq.create()
            ).finish(),
          });
          this.headBUff = open_proto.websocket.Request.encode(
            open_proto.websocket.Request.create(protodata)
          ).finish();
        }
      } catch (error) {}
    },
    initWebSocket() {
      try {
        // 浏览器指纹
        this.browserdata = JSON.parse(localStorage.getItem("browser")) || {};
        if (!this.browserdata?.browser) {
          const browser = generateKey();
          console.log(browser, "browser");
          localStorage.setItem(
            "browser",
            JSON.stringify({ browser: browser.browser, murmur: browser.murmur })
          ); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
          this.browserdata = {
            browser: browser.browser,
            murmur: browser.murmur,
          };
        }
        // Fingerprint2.get((components) => {
        //   // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        //   const values = components.map((component) => component.value); // 配置的值的数组
        //   const murmur = Fingerprint2.x64hash128(values.join(""), 31); // 生成浏览器指纹
        //   this.wsuriParam = {
        //     deviceId: murmur,
        //     deviceName: values[0],
        //   };
        //   this.wsuriParam.clientType = isMobile() ? "h5" : "pc";
        //   this.wsuriParam.network = navigator.connection?.effectiveType; // 网络 3G等

        //   // 初始化参数
        //   this.webSocketParams()
        // });

        this.wsuriParam = {
          deviceId: this.browserdata?.murmur,
          deviceName: this.browserdata?.browser,
        };
        const containerClientType = getContainerClientType();
        // this.wsuriParam.clientType = isMobile() ? "h5" : "pc";
        this.wsuriParam.clientType = containerClientType.clientType;
        this.wsuriParam.containerType = containerClientType.containerType;
        this.wsuriParam.network = navigator.connection?.effectiveType; // 网络 3G等
        this.webSocketParams();
      } catch (error) {
        // 初始化参数
        this.webSocketParams();
      }
    },

    webSocketParams() {
      // console.log(" 建立连接");
      // 建立连接
      if (this.getPacketDomain.websocketUrl) {
        let wsuri =
          this.getPacketDomain.websocketUrl +
          "/connect?token=" +
          this.getToken +
          "&X-Header-Language=" +
          store.getters.getLang;
        wsuri += `&X-Header-Device-Id=${this.wsuriParam.deviceId}`;
        wsuri += `&X-Header-Device-Name=${this.wsuriParam.deviceName}`;
        wsuri += `&X-Header-Client-Type=${this.wsuriParam.clientType}`;
        wsuri += `&X-Header-Container-Type=${this.wsuriParam.containerType}`;
        wsuri += `&X-Header-Network=${this.wsuriParam.network}`;

        // 建立连接
        this.websock = new WebSocket(wsuri);

        this.websock.binaryType = "arraybuffer";
        // 连接成功
        this.websock.onopen = this.websocketonopen;
        // 连接错误
        this.websock.onerror = this.websocketonerror;
        // 接收信息
        this.websock.onmessage = this.websocketonmessage;
        // 连接关闭
        this.websock.onclose = this.websocketclose;
      }
      // 初始化weosocket
    },

    reconnect() {
      // 重新连接
      // console.log(this.getToken, 'this.getToken')
      // console.log('reconnect重新连接')
      const that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        // 新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, that.timeout);
    },
    reset() {
      // 重置心跳
      const that = this;
      // 清除时间
      clearInterval(that.clear_setInterval);
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      // 重启心跳
      // that.start();
    },
    start() {
      // console.log(this.siLogin, "tttttttttttt");
      // console.log("重启心跳");
      // 开启心跳
      const self = this;
      // console.log(self.websock.readyState, "self.websock.readyState ");
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);

      // self.timeoutObj = setTimeout(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息

      if (self.websock.readyState === 1) {
        // 如果连接正常
        // const dataStr = JSON.stringify({ action: 'ping', data: null })
        // self.websock.send(this.headBUff);
        if (!this.headBUff) {
          this.createHeadBUff().then(() => {
            this.websocketsend(this.headBUff);
          });
        } else {
          this.websocketsend(this.headBUff);
        }
      } else {
        // 否则重连
        // 清除时间
        // console.log("清除时间");

        clearInterval(self.clear_setInterval);
        this.websocketclose();
        self.reset();
        // console.log(this.getToken, "this.getToken && this.siLogin");
        if (!this.getToken) {
          this.$store.dispatch("signOutPs");
        }
      }
      // self.serverTimeoutObj = setTimeout(function () {
      //   // 超时关闭
      //   self.websock.close();
      // }, self.timeout);
      // }, self.timeout);
    },
    websocketonopen() {
      // 连接成功事件
      // const dataStr = JSON.stringify({ action: 'ping', data: null })
      // 小红点数据  延迟加载
      const redTimer = setTimeout(() => {
        this.$store.dispatch("getPointApi");
        this.$store.dispatch("refreshPageApi");
        this.$store.dispatch("getUserCoinsAsync");
        clearTimeout(redTimer);
      }, 2000);
      if (!this.headBUff) {
        this.createHeadBUff().then(() => {
          this.websocketsend(this.headBUff);
        });
      } else {
        this.websocketsend(this.headBUff);
      }
      // 提示成功
      // console.log("连接成功", 3);
      // 开启心跳
      // clearInterval(this.clear_setInterval);
      this.clear_setInterval = setInterval(() => {
        const that = this;
        // 清除时间
        clearTimeout(that.timeoutObj);
        clearTimeout(that.serverTimeoutObj);
        // 重启心跳
        // console.log(this.getToken, "重启心跳");
        if (this.getToken && this.isLogin) {
          that.start();
        } else {
          clearInterval(that.clear_setInterval);
          this.reset();
          this.websocketclose();
          this.$store.dispatch("signOutPs");
        }
      }, 5000);
    },
    websocketonerror(res) {
      this.counter = this.counter + 1;
      // 连接失败事件
      // 错误
      // console.log(res, "WebSocket连接发生错误");
      // 重连
      clearInterval(this.clear_setInterval);
      this.websock && this.websock.close();
      clearTimeout(this.timeoutObj);
      this.reset();
      // if (this.counter > 4) {
      //   this.reset();
      //   // console.log(this.counter, "ttttt");
      //   this.websock?.close();
      //   return false;
      // } else {
      // console.log("yyyyyyyyyyyyyyyyyyy");
      if (this.counter > 4) {
        this.timeout = 30 * 1000;
      }
      if (!this.exitKicktype && this.getToken && this.getPacketDomain) {
        this.reconnect();
        //
      }
      // }
    },
    websocketclose(res) {
      //   console.log(res);
      //  Bus.eventExecuted = false
      try {
        clearInterval(this.clear_setInterval);
        this.reset();
        this.websock.close();
        clearTimeout(this.timeoutObj);
        // 收到服务器信息，心跳重置
        // this.websocketclose();
        // 提示关闭
        // console.log(res, "连接已关闭", "------1----");
        const wsslocalStorage = window.localStorage.getItem("wsstype");
        const wssType = window.sessionStorage.getItem("wsstype");
        // console.log(wssType, "wssType&& wsslocalStorage === wssType", wsslocalStorage);
        if (
          wsslocalStorage !== wssType &&
          this.getToken &&
          this.getPacketDomain
        ) {
          console.log("websocketclose =>IllegalLogin");
          this.$isPopShow({
            show: true,
            views: "IllegalLogin",
            data: { close: true },
            // data: { close: true, illegalLogin: "illegalLogin", text: this.$t("Datalang.Login_TITLE_banaccount") },
          });
        } else {
          if (!this.exitKicktype && this.getToken && this.getPacketDomain) {
            // console.log("判读没有收到服务器推送 踢号信息，重连");
            //  判读没有收到服务器推送 踢号信息，重连
            if (this.counter < 4) {
              this.reconnect();
              // if (!isGame()) {
              //   this.$store.dispatch("getUserCoinsAsync");
              // }
            }
            //
          }
          //
        }
      } catch (error) {
        // console.log(error, "------------连接关闭事件异常");
      }
      // 连接关闭事件

      // 重连
      // this.reconnect();
    },
    // 主动请求 需要删除 request
    // requestArrFun(type) {
    //   if(type === 'login') {  // 登录
    //     this.requestArr.push({ path: '/open_proto.websocket.WebsocketPush/Login', callFun: wsFun.Login.bind(this, 'LoginRespPush') })
    //   }
    // },
    // 接收推送消息 不用删除
    pushArrFun() {
      this.pushArr = [
        {
          // 心跳请求
          path: "/open_proto.websocket.WebsocketPush/PingPong",
          callFun: wsFun.PingPong.bind(this, "PingPongRespPush"),
        },
        {
          // 提用户下线
          path: "/open_proto.websocket.WebsocketPush/KickUser",
          callFun: wsFun.KickUser.bind(this, "KickUserRespPush"),
        },
        {
          // http异地登录
          path: "/open_proto.websocket.WebsocketPush/OtherLogin",
          callFun: wsFun.OtherLogin.bind(this, "OtherLoginRespPush"),
        },
        {
          // 系统维护通知
          path: "/open_proto.websocket.WebsocketPush/SystemMaintenanceNotice",
          callFun: wsFun.SystemMaintenanceNotice.bind(
            this,
            "SystemMaintenanceDataPush"
          ),
        },
        {
          // 系统维护开始
          path: "/open_proto.websocket.WebsocketPush/SystemMaintenance",
          callFun: wsFun.SystemMaintenance.bind(
            this,
            "SystemMaintenanceDataPush"
          ),
        },
        {
          // 系统维护结束
          path: "/open_proto.websocket.WebsocketPush/SystemMaintenanceEnd",
          callFun: wsFun.SystemMaintenanceEnd.bind(
            this,
            "SystemMaintenanceDataPush"
          ),
        },
        {
          // VIP升降级
          path: "/open_proto.websocket.WebsocketPush/VipUpgrade",
          callFun: wsFun.VipUpgrade.bind(this, "VipUpgradePush"),
        },
        {
          // 用户余额变更
          path: "/open_proto.websocket.WebsocketPush/UserBalanceChange",
          callFun: wsFun.UserBalanceChange.bind(this, "UserBalanceChangePush"),
        },
        {
          // 完成首次充值
          path: "/open_proto.websocket.WebsocketPush/FirstRecharge",
          callFun: wsFun.FirstRecharge.bind(this, "FirstRechargePush"),
        },
        {
          // 游戏组维护 即将上线
          path: "/open_proto.websocket.WebsocketPush/GameGroupStatusChange",
          callFun: wsFun.GameGroupStatusChange.bind(
            this,
            "GameGroupStatusChangePush"
          ),
        },
        // {
        //   // 打码排行榜奖金发放
        //   path: "/open_proto.websocket.WebsocketPush/BetRankActivityRewardSend",
        //   callFun: wsFun.BetRankActivityRewardSend.bind(
        //     this,
        //     "BetRankActivityRewardSendPush"
        //   ),
        // },
        // {
        //   // 领取新任务
        //   path: "/open_proto.websocket.WebsocketPush/ReceiveNewTask",
        //   callFun: wsFun.ReceiveNewTask.bind(
        //     this,
        //     "ReceiveNewTaskPush"
        //   ),
        // },
        {
          // 任务完成
          path: "/open_proto.websocket.WebsocketPush/TaskComplete",
          callFun: wsFun.TaskComplete.bind(this, "TaskCompletePush"),
        },
        {
          // 下级助力完成
          path: "/open_proto.websocket.WebsocketPush/SubordinateAssist",
          callFun: wsFun.SubordinateAssist.bind(this, "SubordinateAssistPush"),
        },
        {
          // 推送用户站内邮件
          path: "/open_proto.websocket.WebsocketPush/UserSiteEmail",
          callFun: wsFun.UserSiteEmail.bind(this, "UserSiteEmailPush"),
        },
        {
          // 特色模块提现引导是否显示文案
          path: "/open_proto.websocket.WebsocketPush/PushWithdrawGuideText",
          callFun: wsFun.PushWithdrawGuideText.bind(
            this,
            "PushWithdrawGuideTextData"
          ),
        },
        {
          // 红点提示
          path: "/open_proto.websocket.WebsocketPush/RedDot",
          callFun: wsFun.RedDot.bind(this, "RedDotPush"),
        },
        {
          // 出款限制游戏弹窗提示---游戏弹窗
          path: "/open_proto.websocket.WebsocketPush/GamePopUp",
          callFun: wsFun.gamePopUp.bind(this, "GamePopUpPush"),
        },
        {
          // 推送周月卡发放消息
          path: "/open_proto.websocket.WebsocketPush/PushWeekMonthCardGrant",
          callFun: wsFun.PushWeekMonthCardGrant.bind(
            this,
            "WeekMonthCardGrantPush"
          ),
        },
        {
          // 游戏结算---推送破产标识
          path: "/open_proto.websocket.WebsocketPush/Bankrupt",
          callFun: wsFun.bankrupt.bind(this, "BankruptPush"),
        },
        {
          // 获取用户头像
          path: "/open_proto.websocket.WebsocketPush/UserAvatar",
          callFun: wsFun.UserAvatar.bind(this, "UserAvatarPush"),
        },
        {
          // 插入式跑马灯公告消息-推送
          path: "/open_proto.websocket.WebsocketPush/PopMarquee",
          callFun: wsFun.PopMarquee.bind(this, "PopMarqueePush"),
        },
        {
          // 奖励气泡推送
          path: "/open_proto.websocket.WebsocketPush/BonusBalloon",
          callFun: wsFun.BonusBalloon.bind(this, "BonusBalloonPush"),
        },
        {
          // 推送用户获得奖励
          path: "/open_proto.websocket.WebsocketPush/PushUserReward",
          callFun: wsFun.PushUserReward.bind(this, "PushUserRewardPush"),
        },
        {
          // 收款账户变更
          path: "/open_proto.websocket.WebsocketPush/PushUpdateBankCard",
          callFun: wsFun.PushUpdateBankCard.bind(this, "PushUpdateBankCard"),
        },
        // 推送充值任务进度
        {
          path: "/open_proto.websocket.WebsocketPush/PushRechargeTaskProgress",
          callFun: wsFun.PushRechargeTaskProgress.bind(
            this,
            "PushRechargeTaskProgressPush"
          ),
        },
        // 改为进游戏的逻辑
        // {
        //   // 体验彩金上限提示
        //   path: "/open_proto.websocket.WebsocketPush/UserLimitExperienceGold",
        //   callFun: wsFun.UserLimitExperienceGold.bind(this, "UserLimitExperienceGoldPush"),
        // },
      ];
    },
    // requestArr循环
    // requestCallFun(path, data) {
    //   let message = this.requestArr.find(v => {
    //     return v.path === path
    //   })
    //   if(message) {
    //     message.callFun(data)
    //     let index = this.request.indexOf(message);
    //     this.request.splice(index, 1)  // 删除
    //   }
    // },
    // pushArr循环
    pushCallFun(path, data) {
      // console.log("222222", path, this.pushArr);
      const message = this.pushArr.find((v) => {
        return v.path === path;
      });
      if (message) {
        // console.log("00000000000", path, data);
        message.callFun(data);
      }
    },

    websocketonmessage(event) {
      // Bus.eventExecuted = false
      // 接收服务器推送的信息
      // 打印收到服务器的内容
      if (open_proto) {
        const path = wsFun.getCurPath(event.data); // 推送的协议地址
        // console.log(path, "path1111111", event.data, "event.data11111111");
        this.pushCallFun(path, event.data); // 执行推送的协议回调方法
      } else {
        this.$eventPost("wsFun_log");
      }

      // const path = wsFun.getCurPath(event.data); // 推送的协议地址
      // // console.log(path, "path1111111", event.data, "event.data11111111");
      // this.pushCallFun(path, event.data); // 执行推送的协议回调方法
      // const data = JSON.parse(event.data);
      // console.log(
      //   "收到服务器信息11111111111111111111111111111111111",
      //   event,
      //   data
      // );
      // if (data.action === 'changeUserProfile') {
      //   // 更新用户信息
      //   this.$store.commit('wssSetUserInfo', data.data)
      //   this.$store.dispatch('activityfirstWithdrawalInfo')
      // }
      // if (data.action === 'changeBalance') {  //账户信息变更
      //   // 账户信息变更
      //   this.$store.commit('wssSetUserInfo', data.data)
      //   if (!isGame()) {
      //     //   this.$store.dispatch("activityfirstWithdrawalInfo");
      //     this.$store.dispatch('getUserCoinsAsync')
      //   }
      //   // if (
      //   //   url.includes("/user/hWallet") ||
      //   //   url.includes("/user/wallet") ||
      //   //   url.includes("/userCenter")
      //   // ) {
      //   //   Bus.$emit("busGetWalletDetail"); // 钱包接口调用
      //   // }
      // } else if (data.action === 'rechargeSuccess') {
      //   this.$store.dispatch('getUserInfo')
      //   this.$store.dispatch('activityfirstWithdrawalInfo')
      // }
      // if (data.action === 'news') {
      //   if (data?.data?.unread_email_num === 1) {
      //     // 公告
      //     this.$store.commit('setMaildot', true)
      //   }
      //   if (data?.data?.user_notice_num === 1) {
      //     // console.log("你有新公告");
      //   }
      // }
      // if (data.action === 'hideGameByBrandIdMq') {
      //   //  隐藏品牌id
      //   this.$store.commit('setHideBrandId', data.data.brand_id)
      // }
      // if (data.action === 'hideGameByGameIdsMq') {
      //   // 隐藏 游戏id
      //   const lists = data.data.game_ids || []
      //   if (lists.length) {
      //     const arry = getLocalStorage('RECORD_GAMES') || []
      //     let games = []
      //     lists.forEach((element) => {
      //       arry.map(function (item, index) {
      //         if (item.gameGroupSid !== element) {
      //           games.push(item)
      //         }
      //       })
      //     })
      //     games = new Set([...arry])
      //     setLocalStorage('RECORD_GAMES', games)
      //   }
      //   this.$store.commit('setHideGameId', lists)
      // }
      // if (data.action === 'hideGameByGameRefTemplateIdsMq') {
      //   // 隐藏游戏模板id
      //   this.$store.commit('setHideTmpGameIds', data.data.ids)
      // }
      // if (data.action === 'userHasBeenRestricted_ws') {
      //   // 会员限制登录
      //   this.websocketclose()
      //   this.$store.dispatch('signOutPs')
      //   this.$isPopShow({
      //     show: true,
      //     views: 'IllegalLogin',
      //     data: { text: this.$t('Datalang.Login_TITLE_banaccount') },
      //   })
      // }
      // if (data.action === 'exitKick') {
      //   console.log('异地登录1111111_exitKick')
      //   // 异地登录

      //   this.exitKicktype = true

      //   this.websocketclose()
      //   // this.$store.dispatch("signOutPs");
      //   const wsslocalStorage = window.localStorage.getItem('wsstype')
      //   const wssType = window.sessionStorage.getItem('wsstype')
      //   if (wsslocalStorage === wssType) {
      //     this.$isPopShow({
      //       show: true,
      //       views: 'IllegalLogin',
      //       data: {
      //         text: null,
      //         illegalLogin: 'illegalLogin',
      //         close: true,
      //       },
      //     })
      //   }

      //   // try {
      //   //   this.getWebResource();
      //   // } catch (error) {
      //   //   // console.log(error, "---------------");
      //   // }
      // }
      // //   账户挤号
      // if (data.action === 'token_invalid') {
      //   this.exitKicktype = true
      //   // this.token_invalid_type = true;
      //   // console.log("token_invalid");
      //   this.websocketclose()
      //   localStorage.setItem('IS_LOGIN', false)
      //   removeToken()
      //   // this.$isPopShow({
      //   //   show: true,
      //   //   views: "IllegalLogin",
      //   // });
      //   // removeLocalStorage("IS_LOGIN");
      //   // removeLocalStorage("activityfirstWithdrawal");
      //   // this.$store.dispatch("signOutPs");
      // }

      // if (data.action === 'system_maintenance_list_ws') {
      //   // 游戏维护
      //   webResource()
      // }
      // if (data.action === 'rechargeSuccessEvent') {
      //   console.log('rechargeSuccessEvent', data.data)
      //   this.$store.commit('wssSetUserInfo', { is_recharge: true })
      //   const { charge_amount, coinCode, order_number } = data.data || {}
      //   let realAmount = charge_amount
      //   try {
      //     const userCoins = this.$store.getters.getUserCoins
      //     const wallets = userCoins?.wallets || []
      //     const curCoinObj = wallets.find((item) => item.coinCode === coinCode) || {};
      //     const accuracy = curCoinObj.accuracy
      //     realAmount = divideAccuracy(charge_amount, accuracy)
      //     // 充值成功
      //     console.log('充值成功', accuracy, realAmount)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
      // if (data.action === 'marqueeWithdrawSuccess') {
      //   console.log('marqueeWithdrawSuccess', data.data)
      //   const { money, coinCode, order_number } = data.data || {}
      //   let realAmount = money
      //   try {
      //     const userCoins = this.$store.getters.getUserCoins
      //     const wallets = userCoins?.wallets || []
      //     const curCoinObj = wallets.find((item) => item.coinCode === coinCode) || {};
      //     const accuracy = curCoinObj.accuracy
      //     realAmount = divideAccuracy(money, accuracy)
      //     // 提现成功
      //     console.log('提现成功', data.data, accuracy, realAmount)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }

      // // 有新任务可领取
      // if (data.action === 'taskCanReceiveCount') {
      //   this.$store.commit('taskDot', data.data?.can_receive_count || 0)
      // }
      // if (data.action === 'cashBonusReward_ws') {
      //   // 现金红包完成之后的推送
      //   Bus.$emit('cashBonusSuccess')
      //   const data = { status: 3 }
      //   this.$winPop.cashEnvelopePop(data, this.$t('Datalang.Bonuses_TITLE_cashbonus'), 2)
      // }

      // 收到服务器信息，心跳重置
      // this.reset();
    },
    websocketsend(msg) {
      if (this.websock && this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(msg);
      }
    },
  },
};
